import Head from "next/head"
import { DefaultLayout } from "src/components/Layout"
import { CalculatorContainer } from "src/features/calculator/components/CalculatorContainer"

function CalculatorPage() {
  return (
    <DefaultLayout>
      <Head>
        <title>送金額計算書 | for CS</title>
      </Head>
      <div className="ml-12 mt-12">
        <CalculatorContainer />
      </div>
    </DefaultLayout>
  )
}

export default CalculatorPage
